'use client';

import { DegreePlanningWorkspace } from '@/app/degree-planning/Workspace';
import GpaPlanner from '@/app/gpa-calculator/GpaPlanner';
import { PrerequisiteCheckerWorkspace } from '@/app/prerequisite-checker/Workspace';
import { ProfilePageWorkspace } from '@/app/profile/Workspace';
import type { PlanView } from './planningNavigation';

export function PlanningEmbeddedWorkspace({ view }: { view: PlanView }) {
  switch (view) {
    case 'requirements':
      return <PrerequisiteCheckerWorkspace key={view} embedded initialTab="checker" />;
    case 'ap':
      return <PrerequisiteCheckerWorkspace key={view} embedded initialTab="ap-credits" />;
    case 'transfer':
      return <DegreePlanningWorkspace embedded openTransferOptions />;
    case 'record':
      return <ProfilePageWorkspace embedded forcedTab="previous_classes" />;
    case 'gpa':
      return <GpaPlanner embedded />;
    default:
      return <DegreePlanningWorkspace embedded />;
  }
}
